class Common {
  constructor(el,opt){
    this.event();
  }
  event(){
    $('.js-drawer-trigger').click(function(){
      $('html').toggleClass('is-drawer');
      scrollBan();
    });

    $('.js-drawer-accordion').click(function(){
      $(this).next().slideToggle();
      $(this).find('.trigger').toggleClass('is-open');
    });

    // pcだけの場合のみ実行
    if (window.matchMedia('(min-width: 768px)').matches) {

      const showMega = (trigger, container) => {
        trigger.addClass('is-hover');
        container.addClass('is-hover');
      };
      const hideMega = (trigger, container) => {
        trigger.removeClass('is-hover');
        container.removeClass('is-hover');
      };

      $('.js-mega-trigger').hover(
        function(){
          let target = $(this).data('mega-target');
          showMega($(this), $("[data-mega-container='"+target+"']"));
        },
        function(){
          let target = $(this).data('mega-target');
          hideMega($(this), $("[data-mega-container='"+target+"']"));
        }
      );

      $('.js-mega-container').hover(
        function(){
          let container = $(this).data('mega-container');
          showMega($("[data-mega-target='"+container+"']"), $(this));
        },
        function(){
          let container = $(this).data('mega-container');
          hideMega($("[data-mega-target='"+container+"']"), $(this));
        }
      );
    }

    // 20pxスクロールしたら、htmlに.is-scrollをつけたい
    $(window).on('scroll', function() {
      if ($(this).scrollTop() > 20) {
        $('html').addClass('is-scroll');
      } else {
        $('html').removeClass('is-scroll');
      }
    });
  }
}
